import React from 'react';

import type { MatchQuery } from '@confluence/route/entry-points/matchUrl.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { HOME } from '@confluence/named-routes/entry-points/routes.ts';

export function RedirectToHomeWithQuery(extra: MatchQuery): {
	({ query }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(): boolean;
} {
	const redirectComponent = ({ query }: RouteMatch) => (
		<Redirection name={HOME.name} params={{ query: { ...query, ...extra } }} />
	);
	redirectComponent.NAVIGATION_PARAMS = () => false;
	return redirectComponent;
}
